import { useEffect, useState } from "react";
import { Fuel, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "../../lib/api";

const inputCls = "h-12 w-full min-w-0 rounded-xl border border-black/10 bg-white px-3";

export const FuelLoad = () => {
  const [open, setOpen] = useState(false);
  const [list, setList] = useState([]);
  const [f, setF] = useState({ vehicle_id: "", liters: "", amount: "", km: "", station: "" });
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open && !list.length) api.get("/driver/vehicles").then((r) => setList(Array.isArray(r.data) ? r.data : [])).catch(() => {}); }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/driver/fuel", { ...f, liters: Number(f.liters), amount: Number(f.amount || 0), km: Number(f.km) });
      toast.success("Carga registrada"); setF({ vehicle_id: f.vehicle_id, liters: "", amount: "", km: "", station: "" }); setOpen(false);
    } catch (err) { toast.error(apiError(err)); } finally { setBusy(false); }
  };
  if (!open) return <button onClick={() => setOpen(true)} data-testid="fuel-open" className="mb-4 inline-flex h-12 w-full items-center justify-center gap-2 rounded-2xl bg-white font-bold ring-1 ring-black/10"><Fuel className="h-5 w-5 text-[var(--forest)]" /> Cargar combustible y km</button>;
  return (
    <form onSubmit={save} data-testid="fuel-form" className="mb-4 space-y-2 rounded-2xl bg-white p-4 ring-1 ring-black/10">
      <p className="flex items-center gap-2 font-bold"><Fuel className="h-5 w-5 text-[var(--forest)]" /> Carga de combustible</p>
      <select data-testid="fuel-vehicle" required value={f.vehicle_id} onChange={set("vehicle_id")} className={inputCls}><option value="">Unidad…</option>{list.map((v) => <option key={v.id} value={v.id}>Int. {v.interno} · {v.patente} ({v.km.toLocaleString("es-AR")} km)</option>)}</select>
      <div className="grid grid-cols-2 gap-2">
        <input data-testid="fuel-liters" required type="number" step="0.01" inputMode="decimal" placeholder="Litros" value={f.liters} onChange={set("liters")} className={inputCls} />
        <input data-testid="fuel-amount" type="number" inputMode="decimal" placeholder="Importe $" value={f.amount} onChange={set("amount")} className={inputCls} />
        <input data-testid="fuel-km" required type="number" inputMode="numeric" placeholder="Km del tablero" value={f.km} onChange={set("km")} className={inputCls} />
        <input data-testid="fuel-station" placeholder="Estación / lugar" value={f.station} onChange={set("station")} className={inputCls} />
      </div>
      <div className="flex gap-2">
        <button type="button" onClick={() => setOpen(false)} className="h-12 rounded-xl border border-black/10 px-4 font-semibold">Cancelar</button>
        <button data-testid="fuel-save" disabled={busy} className="flex h-12 flex-1 items-center justify-center gap-2 rounded-xl bg-[var(--forest)] font-bold text-white">{busy && <Loader2 className="h-4 w-4 animate-spin" />} Guardar carga</button>
      </div>
    </form>
  );
};
